import { useEffect, useState } from "react"
import { Card, Button, Spinner, Row, Col, Modal, CloseButton } from 'react-bootstrap';
import DataGrid from '../../controls/DataGrid.js/DataGrid'
import { useSelector } from 'react-redux';
import Icon from "../../controls/Icons/Icon";
import { useNavigate } from 'react-router-dom';
import { dateDisplayFormater, getDateSaveFormat } from "../../../Utils";
import useFetchWithCancellation from "../../../customhooks/useFetchWithCancellation";
import ClientSearchForm from '../Client/ClientSearchForm';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandler from "../../controls/ErrorHandler";
import CreateTicket from "./CreateTicket";
import "../Ticket/ViewTicket.css"; 
//import TicketSearchForm from "./TicketSearchForm";
import TicketSearchForm_InProgress from "./TicketSearchForm_InProgress";
import TicketSearchForm from "./TicketSearchForm";
export default function ViewTicket() {
    const { fetchData } = useFetchWithCancellation();
    const state = useSelector(state => state);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [showSearchForm, setshowSearchForm] = useState(false);
    const [showTicketForm, setshowTicketForm] = useState(false);
    const [ClientSelected, setClientSelected] = useState(false);
    const [querystring, setquerystring] = useState("");
    const [dataGridUrl, setdataGridUrl] = useState(state.projectdetail.API + "/Ticket/TicketsFormGrid");
    const columns = [
        {
            field: "TicketNumber",
            title: "Ticket Number",
            sortName: "TicketNumber",
            sortable: true,
        },
        {
            field: "IssueDetails",
            title: "Issue Details",
            sortable: true,
            visible: true,
        },
        {
            field: "FunctionalArea",
            title: "Functional Area",
            sortable: true,
        }, //TicketType
        {
            field: "TicketType",
            title: "Ticket Type",
            sortable: true,
        },

        {
            field: "TicketStatus",
            title: "Ticket Status",
            sortable: true,
        },
        {
            field: "IssueOwner",
            title: "Issue Owner",
            sortable: false,
            visible: false,
        },
        {
            field: "CreatedBy",
            title: "Created By",
            sortable: true,
            visible: true,
        },
        {
            field: "CreatedDate",
            title: "Created Date",
            sortable: false,
            formatter: dateDisplayFormater
        },
        {
            field: "UpdatedDate",
            title: "Resolved Date",
            sortable: false,
            formatter: (cellContent, row) => {
                if (row.UpdatedDate == "0001-01-01T00:00:00") {
                    return (<div></div>)
                } else {
                    return (<div>
                        {dateDisplayFormater(row.UpdatedDate)}
                    </div>)
                }
            }   
        },
       
        //{
        //    field: "UpdatedDate",
        //    title: "Updated Date",
        //    sortable: false,
        //    formatter: dateDisplayFormater
        //},

        {
            dataField: "Update",
            title: "",
            text: "Update",
            formatter: (cellContent, row) => {
                return (<div>
                    {state.access.edit ? <Button text="Update" variant="link" tooltip="Update Ticket Status"
                        className="btn-xs me-2 p-0" variant="link"
                        onClick={() => handleEdit(row, 1)}> <Icon name="BsPiggyBankFill" title="Update" className='fs-5' /></Button> : ""}
                </div>
                );
            },
        }
    ];
    const [isEdit, setisEdit] = useState(false);
    const [selectedTicketId, setselectedTicketId] = useState("");
    const handleEdit = (res, to) => {
       // console.log(res);
        setisEdit(true);
        setselectedTicketId(res.Id);
        setshowTicketForm(true);

       
       // window.alert("Development is in progress");
        //if (to == 1)
        //    navigate("/admin/pcpform/" + res.Id + "/personal");
        //else
        //    navigate("/admin/pcpform/" + res.Id + "/spendingplangenerator");
    };


    

    const handleAdd = () => {
        setisEdit(false);

        setshowTicketForm(true);
    };
    
    const handleAfter = (inputValue) => {
        setshowSearchForm(false);
        setClientSelected(true);

        let updatedQueryStr = "TicketNumber=" + inputValue.TicketNumber + "&&" +
            "fkFunctionalAreaId=" + inputValue.fkFunctionalAreaId + "&&" +
            "fkTicketStatusId=" + inputValue.fkTicketStatusId + "&&" +
            "fkTicketTypeId=" + inputValue.fkTicketTypeId + "&&" +
            "IssueOwnerId=" + inputValue.IssueOwnerId + "&&" +
            "CreatedDate=" + getDateSaveFormat(inputValue.CreatedDate);

        setdataGridUrl(state.projectdetail.API + "/Ticket/SearchTicketGrid?" + updatedQueryStr)
        setRefreshGrid(!refreshGrid);

    }
    const handleAfterTicketForm = () => {
        setshowTicketForm(false);
        setRefreshGrid(!refreshGrid);
    }
    const handleClose = () => {
        setshowSearchForm(false);
    };

    const handlerefreshSearch = () => {
        // setdataGridUrl(state.projectdetail.API + "/client/ClientFormGrid");
        setdataGridUrl(state.projectdetail.API + "/Ticket/TicketsFormGrid");
        setRefreshGrid(!refreshGrid);
    };
    const handleShowTicketForm = () => {
        // setshowSearchForm(true);
        setshowTicketForm(true);
    };
    const handleSearchTicketForm = () => {
        setshowSearchForm(true);
    }
    const handleCloseTicketForm = () => {
        setshowTicketForm(false);
    }
    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "Tickets",
        toolbar: <div><Button onClick={handleAdd}>Add New Ticket</Button> </div>
    };
    return (
        <div>
            <ErrorBoundary FallbackComponent={ErrorHandler}>
                <Row>
                    <Col md={6}>
                        <h4 className='form-heading'>
                            Ticket &nbsp;&nbsp;&nbsp;&nbsp; <Icon style={{ cursor: "pointer" }} name="BsSearch" title="Ticket Search" className='fs-5' onClick={handleSearchTicketForm} />
                            &nbsp;&nbsp; <Icon style={{ cursor: "pointer" }} name="BsArrowClockwise" title="Refresh" className='fs-5' onClick={handlerefreshSearch} />
                        </h4>
                    </Col>
                    {/*<Col md={6}>*/}
                    {/*    <h4 className='form-heading'>*/}
                    {/*       <Button variant="primary" onClick={handleAdd}>Add New Ticket</Button> */}
                    {/*        <Icon style={{ cursor: "pointer" }} name="BsSearch" title="Ticket Search" className='fs-5' onClick={handleSearchTicketForm} />*/}
                    {/*        &nbsp;&nbsp; <Icon style={{ cursor: "pointer" }} name="BsArrowClockwise" title="Refresh" className='fs-5' onClick={handlerefresh} />*/}
                    {/*    </h4>*/}
                    {/*</Col>*/}
                </Row>
                <div>
                    <Modal centered show={showSearchForm} onHide={handleClose}
                        size="sm" backdrop="static" keyboard={false}
                        dialogClassName="custom-modal1" >
                        <Modal.Header style={{ background: "#0a4081", color: "white" }}>
                            <h4 style={{ fontcolor: 'white' }} > Search Ticket details </h4>
                            <CloseButton onClick={handleClose} className="btn-close" />
                        </Modal.Header>
                        <Modal.Body>
                            <TicketSearchForm afterSave={handleAfter} onCancel={handleClose} />
                        </Modal.Body>
                    </Modal>

                    <Modal show={showTicketForm} onHide={handleCloseTicketForm}
                        size="xl" backdrop="static" keyboard={false}
                        dialogClassName="custom-modal-position" >
                        <Modal.Header style={{ background: "#0a4081", color: "white" }}>
                             {isEdit &&
                                <h4 style={{ fontcolor: 'white' }} >  Edit Ticket </h4>
                            } 
                            {!isEdit &&
                                <h4 style={{ fontcolor: 'white' }} >  Create New Ticket </h4>
                            } 
                            <CloseButton onClick={handleCloseTicketForm} className="btn-close" />
                        </Modal.Header>
                        <Modal.Body style={{align:'center'} }>
                            <CreateTicket afterSave={handleAfterTicketForm} onCancel={handleCloseTicketForm} isEdit={isEdit} TicketId={selectedTicketId} />
                        </Modal.Body>
                    </Modal>
                </div>
                <Card>
                    <Card.Body>
                        {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                        <DataGrid url={dataGridUrl} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />
                    </Card.Body>
                </Card>
            </ErrorBoundary>
            );

        </div>

    )
}